import React, { useEffect, useMemo, useState } from "react";
import { FaCopy, FaCog } from "react-icons/fa";

const CopyWeekShiftPopup = ({
  visible,
  onClose,

  currentDate,

  onConfirm,
}) => {

  const getMonday = (date) => {
    const d = new Date(date);

    const day = (d.getDay() + 6) % 7;

    d.setHours(0, 0, 0, 0);

    d.setDate(d.getDate() - day);

    return d;
  };

  const getISOWeek = (date) => {

    const d = new Date(date);

    d.setHours(0, 0, 0, 0);

    d.setDate(d.getDate() + 3 - ((d.getDay() + 6) % 7));

    const week1 = new Date(d.getFullYear(), 0, 4);

    return (
      1 +
      Math.round(
        (
          (
            d.getTime() -
            week1.getTime()
          ) /
          86400000 -
          3 +
          ((week1.getDay() + 6) % 7)
        ) / 7
      )
    );
  };

  const formatWeekLabel = (weekValue) => {

    if (!weekValue) return "";

    const [, week] =
        weekValue.split("-W");

    return `Vecka ${parseInt(week, 10)}`;
    };

  const formatWeekValue = (date) => {

    const d = new Date(date);

    const year = d.getFullYear();

    const week = String(
      getISOWeek(d)
    ).padStart(2, "0");

    return `${year}-W${week}`;
  };

  const currentWeekValue = useMemo(() => {
    return formatWeekValue(
      getMonday(currentDate)
    );
  }, [currentDate]);

  const nextWeekValue = useMemo(() => {

    const d = getMonday(currentDate);

    d.setDate(d.getDate() + 7);

    return formatWeekValue(d);

  }, [currentDate]);

  const [sourceWeek, setSourceWeek] = useState(currentWeekValue);

  const [targetWeek, setTargetWeek] = useState(nextWeekValue);

  const [copySettings, setCopySettings] = useState({

    employees: true,
    project: true,
    times: true,
    breaks: false,
    overtime: false,
    absences: false,
    notes: false,
    // applications: true,
  });

  const [showConfirmPopup, setShowConfirmPopup] = useState(false);

  useEffect(() => {

    if (!visible) return;

    setSourceWeek(currentWeekValue);

    setTargetWeek(nextWeekValue);

  }, [
    visible,
    currentWeekValue,
    nextWeekValue,
  ]);

  if (!visible) return null;

  const settingRow = (
    key,
    label,
    description
  ) => {

    const active = copySettings[key];

    return (
      <button
        key={key}
        type="button"
        onClick={() => {
          setCopySettings(prev => ({
            ...prev,
            [key]: !prev[key],
          }));
        }}
        style={{
          width: "100%",
          border: active
            ? "1px solid #bfdbfe"
            : "1px solid #e5e7eb",

          background: active
            ? "#eff6ff"
            : "#ffffff",

          borderRadius: 10,

          padding: "12px 14px",

          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",

          cursor: "pointer",

          transition: "all 120ms ease",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 2,
          }}
        >
          <span
            style={{
              fontSize: 14,
              fontWeight: 700,
              color: "#111827",
            }}
          >
            {label}
          </span>

          <span
            style={{
              fontSize: 12,
              color: "#6b7280",
            }}
          >
            {description}
          </span>
        </div>

        <div
          style={{
            width: 18,
            height: 18,
            borderRadius: 999,

            background: active
              ? "#2563eb"
              : "#e5e7eb",

            transition: "all 120ms ease",
          }}
        />
      </button>
    );
  };

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.45)",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        zIndex: 999999,
        padding: 20,
        boxSizing: "border-box",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: 620,
          maxWidth: "100%",

          background: "#ffffff",

          borderRadius: 18,

          padding: 24,

          boxShadow: "0 20px 60px rgba(0,0,0,0.18)",

          border: "1px solid #e5e7eb",
        }}
      >

        {/* HEADER */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            marginBottom: 24,
          }}
        >
          <div
            style={{
              width: 44,
              height: 44,
              borderRadius: 12,

              background: "#2563eb",

              display: "flex",
              alignItems: "center",
              justifyContent: "center",

              color: "white",
              fontSize: 18,

              flexShrink: 0,
            }}
          >
            <FaCopy />
          </div>

          <div>
            <h2
              style={{
                margin: 0,
                fontSize: 22,
                fontWeight: 800,
                color: "#111827",
              }}
            >
              Kopiera vecka
            </h2>

            <p
              style={{
                margin: 0,
                marginTop: 4,
                fontSize: 13,
                color: "#6b7280",
              }}
            >
              Kopiera hela veckoschemat till en annan vecka
            </p>
          </div>
        </div>

        {/* WEEK SELECTORS */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 14,
            marginBottom: 22,
          }}
        >

          {/* FROM */}
          <div>
            <label
              style={{
                display: "block",
                marginBottom: 7,

                fontSize: 13,
                fontWeight: 700,
                color: "#374151",
              }}
            >
              Från vecka
            </label>

            <input
              type="week"
              value={sourceWeek}
              onChange={(e) => {
                setSourceWeek(e.target.value);
              }}
              style={{
                width: "100%",
                height: 48,

                border: "1px solid #d1d5db",
                borderRadius: 10,

                padding: "0 12px",

                fontSize: 14,

                boxSizing: "border-box",

                outline: "none",
              }}
            />
          </div>

          {/* TO */}
          <div>
            <label
              style={{
                display: "block",
                marginBottom: 7,

                fontSize: 13,
                fontWeight: 700,
                color: "#374151",
              }}
            >
              Till vecka
            </label>

            <input
              type="week"
              value={targetWeek}
              onChange={(e) => {
                setTargetWeek(e.target.value);
              }}
              style={{
                width: "100%",
                height: 48,

                border: "1px solid #d1d5db",
                borderRadius: 10,

                padding: "0 12px",

                fontSize: 14,

                boxSizing: "border-box",

                outline: "none",
              }}
            />
          </div>
        </div>

        {/* SETTINGS */}
        <div
          style={{
            border: "1px solid #e5e7eb",
            borderRadius: 14,

            padding: 16,

            marginBottom: 24,
          }}
        >

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,

              marginBottom: 14,
            }}
          >
            <FaCog
              style={{
                color: "#6b7280",
                fontSize: 14,
              }}
            />

            <span
              style={{
                fontSize: 14,
                fontWeight: 700,
                color: "#111827",
              }}
            >
              Inställningar
            </span>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 10,
            }}
          >

            {settingRow(
              "employees",
              "Anställda",
              "Kopiera tilldelade anställda"
            )}

            {settingRow(
              "project",
              "Projekt",
              "Kopiera projektkoppling"
            )}

            {settingRow(
              "times",
              "Tider",
              "Kopiera start/sluttider"
            )}

            {settingRow(
              "breaks",
              "Raster",
              "Kopiera raster"
            )}

            {settingRow(
              "overtime",
              "Övertid",
              "Kopiera övertidsregler"
            )}

            {settingRow(
              "absences",
              "Frånvaro",
              "Kopiera frånvaro"
            )}

            {settingRow(
              "notes",
              "Meddelanden",
              "Kopiera meddelanden/noteringar"
            )}

            {/* {settingRow(
              "applications",
              "Ansökningar",
              "Behåll ansökningsinställningar"
            )} */}

          </div>
        </div>

        {/* ACTIONS */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 10,
          }}
        >
          <button
            onClick={onClose}
            style={{
              height: 44,

              padding: "0 18px",

              borderRadius: 10,

              border: "1px solid #d1d5db",

              background: "#ffffff",

              cursor: "pointer",

              fontWeight: 700,

              color: "#111827",
            }}
          >
            Avbryt
          </button>

        <button
            onClick={() => {
                setShowConfirmPopup(true);
            }}
            style={{
              height: 44,

              padding: "0 18px",

              borderRadius: 10,

              border: "none",

              background: "#2563eb",

              color: "white",

              cursor: "pointer",

              fontWeight: 800,

              display: "inline-flex",
              alignItems: "center",
              gap: 8,

              boxShadow: "0 6px 18px rgba(37,99,235,0.25)",
            }}
          >
            <FaCopy />

            Kopiera vecka
          </button>
        </div>
      </div>
      {showConfirmPopup && (
        <div
            style={{
            position: "fixed",
            inset: 0,

            background:
                "rgba(0,0,0,0.45)",

            backdropFilter: "blur(3px)",

            display: "flex",
            alignItems: "center",
            justifyContent: "center",

            zIndex: 9999999,
            }}
        >
            <div
            style={{
                width: 420,
                maxWidth: "90%",

                background: "#fff",

                borderRadius: 18,

                padding: 24,

                boxShadow:
                "0 25px 70px rgba(0,0,0,0.22)",

                border:
                "1px solid #e5e7eb",
            }}
            >

            {/* ICON */}
            <div
                style={{
                width: 58,
                height: 58,

                borderRadius: 16,

                background:
                    "linear-gradient(135deg,#2563eb,#3b82f6)",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                color: "white",

                fontSize: 22,

                marginBottom: 18,
                }}
            >
                <FaCopy />
            </div>

            {/* TITLE */}
            <h3
                style={{
                margin: 0,
                marginBottom: 10,

                fontSize: 24,
                fontWeight: 800,

                color: "#111827",
                }}
            >
                Kopiera vecka?
            </h3>

            {/* TEXT */}
            <p
                style={{
                margin: 0,

                fontSize: 14,
                lineHeight: 1.6,

                color: "#6b7280",
                }}
            >
                Du håller på att kopiera hela
                veckoschemat från{" "}
                <strong
                style={{
                    color: "#111827",
                }}
                >
                {formatWeekLabel(sourceWeek)}
                </strong>{" "}
                till{" "}
                <strong
                style={{
                    color: "#111827",
                }}
                >
                {formatWeekLabel(targetWeek)}
                </strong>.
            </p>

            <p
                style={{
                marginTop: 14,

                fontSize: 13,

                color: "#9ca3af",
                }}
            >
                Detta kan skapa många nya pass.
            </p>

            {/* BUTTONS */}
            <div
                style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 10,

                marginTop: 26,
                }}
            >

                <button
                onClick={() => {
                    setShowConfirmPopup(false);
                }}
                style={{
                    height: 44,

                    padding: "0 18px",

                    borderRadius: 10,

                    border:
                    "1px solid #d1d5db",

                    background: "#fff",

                    color: "#111827",

                    cursor: "pointer",

                    fontWeight: 700,
                }}
                >
                Avbryt
                </button>

                <button
                onClick={() => {

                    setShowConfirmPopup(false);

                    onConfirm({

                    sourceWeek,
                    targetWeek,

                    settings: copySettings,
                    });
                }}
                style={{
                    height: 44,

                    padding: "0 18px",

                    borderRadius: 10,

                    border: "none",

                    background:
                    "linear-gradient(135deg,#2563eb,#3b82f6)",

                    color: "white",

                    cursor: "pointer",

                    fontWeight: 800,

                    display: "flex",
                    alignItems: "center",
                    gap: 8,

                    boxShadow:
                    "0 10px 25px rgba(37,99,235,0.25)",
                }}
                >
                <FaCopy />
                Kopiera vecka
                </button>
            </div>
            </div>
        </div>
        )}
    </div>
    
  );
};

export default CopyWeekShiftPopup;